import styled from 'styled-components'
import { useTranslation } from 'contexts/Localization'
import { Flex, Text } from 'vvs-uikit'

export const Content = styled(Flex)`
  height: 100%;
  align-items: center;
`

const QuestHistoryEmpty = () => {
  const { t } = useTranslation()
  return (
    <Content>
      <Flex alignItems="center" flexDirection="column" flex="1">
        <Text color="black" fontSize="20px">
          (´∀`)
        </Text>
        <Text color="black" small>
          {t('Get started on your first quest!')}
        </Text>
      </Flex>
    </Content>
  )
}

export default QuestHistoryEmpty
